import api from "../../../services/api.service"


export const typeformModule = {
    namespaced: true,
    state: {
        data: {types:[],categories:[]},
    },
    getters: {
        canReadRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('real_estate');
        },
        canEditRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('real_estate');
        },
        getAllCategories(state) {
            if (state.data == null || state.data.categories == null)
                return [];
            return state.data.categories;
        },

        getAllTypes(state) {
            if (state.data == null || state.data.types == null)
                return [];
            return state.data.types;
        },

        allTypeformStatus() {
            return [
                { value: "online", text: ('ONLINE') },
                { value: "offline", text: ('OFFLINE') },
                { value: "inProgress", text: ('IN PROGRESS') },
                { value: "error", text: ('ERROR') }
            ];
        },



    },
    mutations: {
        updateData(state, data) {
            let stateData = {};
            stateData.loaded = true;
            stateData.categories = data["Categories"];
            stateData.types = data["Types"];
            state.data = stateData;
        }
    },
    actions: {

        copySuccess(actions,id){
            actions.dispatch('notifications/success',
                {title: 'Success', message: 'Typeform  ID '+id+' copied'},
                {root: true});

        },


        getAll(actions,{ page, amount, filter,sortcolumn, sortby }) {

            return new Promise(function (resolve, reject) {

                    api.sendRequest('typeform/get', {
                        buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                        page,
                        amount,
                        sortcolumn,
                        sortby
                    },filter).then(
                        (ans) => {
                            if (ans["Typeforms"] == null)
                                return reject('Could not get Typeforms ');

                            resolve(ans);
                        }, (error) => {
                            reject(error.message)
                        })
                })

        },


        deleteOne(actions,{id}){
            return new Promise((resolve, reject) => {

                api.sendRequest('typeform/delete/'+id, {}).then(
                    (ans) => {

                        if (ans["Deleted"] == null)
                            return reject('Could not delete item ');

                        resolve(ans["Deleted"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        updateTypeForm(actions,{form}){
            return new Promise((resolve, reject) => {

                api.sendRequest('typeform/update',null, form).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Update form', message: 'Updated successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not update form ');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        createTypeForm(actions,{form}){
            return new Promise((resolve, reject) => {

                api.sendRequest('typeform/create',null, form).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Create form', message: 'Created successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not create form ');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },

        updateStatus(actions,{ page, amount, filter,sortcolumn, sortby }) {

            return new Promise(function (resolve, reject) {

                    api.sendRequest('typeform/get', {
                        buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                        page,
                        amount,
                        sortcolumn,
                        sortby
                    },filter).then(
                        (ans) => {
                            if (ans["Typeforms"] == null)
                                return reject('Could not get Typeforms ');

                            resolve(ans);
                        }, (error) => {
                            reject(error.message)
                        })
                })

        },


    },
};
